import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en', // Force English as default language (translation incomplete for other languages)
    fallbackLng: 'en',
    debug: true, // Enable debug to see loading issues
    supportedLngs: ['en', 'am'],
    
    detection: {
      order: ['localStorage'], // Only check localStorage, ignore browser language
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: [
      'common',
      'navigation',
      'dashboard',
      'strategic',
      'financial',
      'tooltips',
      'errors',
      'notifications',
      'analytics',
      'performance',
      'enterprise',
      'admin',
      'affiliate',
      'subscription',
      'export',
      'cost',
      'setup'
    ],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

// Set document language attribute (no RTL for Amharic, it's LTR)
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = 'ltr'; // Always LTR for both English and Amharic
  document.documentElement.lang = lng;
});

// Set initial direction to LTR
document.documentElement.dir = 'ltr';
document.documentElement.lang = i18n.language || 'en';

export default i18n;
